import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MdbModalRef } from 'mdb5-adapted';
import { MdbRippleModule } from 'mdb5-adapted';
import { AreaModel, RegionModel } from 'src/app/core/models/region.model';

import { LMS_NoSpecialsDirective, LmsModalFrameComponent, UpperCaseInputDirective } from '@lmsSharedUI';

@Component({
  selector: 'app-area-add',
  templateUrl: './area-add.component.html',
  styleUrls: ['./area-add.component.scss'],
  standalone: true,
  imports: [
    LmsModalFrameComponent,
    FormsModule,
    ReactiveFormsModule,
    LMS_NoSpecialsDirective,
    UpperCaseInputDirective,
    NgIf,
    MdbRippleModule,
  ],
})
export class AreaAddComponent {
  areaForm = this.fb.group({
    region: '',
    areaCtrl: '',
  });
  submitted: boolean = false;
  areaRec: AreaModel;
  areaModel: AreaModel;
  regionNo: any;
  region: any;
  lstRegions: RegionModel[];
  selectedRegion: RegionModel;

  constructor(public dialogRef: MdbModalRef<AreaAddComponent>, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.submitted = false;
    this.selectedRegion = this.region;

    // Use optional chaining in case tests do not provide `areaRec`.
    this.areaForm.setValue({
      region: this.areaRec?.region?.name || '',
      areaCtrl: this.areaRec?.name || '',
    });
  }

  get areaCtrl() {
    return this.areaForm?.controls?.areaCtrl;
  }

  saveArea() {
    this.submitted = true;

    if (!this.areaForm.valid) {
      return;
    }

    this.areaModel = new AreaModel();
    const regionval = { id: this.selectedRegion.id, name: this.selectedRegion.name } as RegionModel;
    this.areaModel.region = regionval;
    this.areaModel.id = 0;
    this.areaModel.name = this.areaForm.controls.areaCtrl.value || 'unnamed Area';
    this.dialogRef.close(this.areaModel);
  }

  close() {
    this.dialogRef.close();
  }
}
